import { ReactNode } from 'react'

interface PayLayoutProps {
  children: ReactNode
  wide?: boolean
}

const PayLayout = ({ children, wide }: PayLayoutProps) => {
  return (
    <div className="page-container section-padding animate-fade-in">
      <div className={wide ? 'max-w-4xl mx-auto' : 'max-w-xl mx-auto'}>
        {children}
      </div>
    </div>
  )
}

export default PayLayout
